import { useState } from 'react';
import { Switch as AntSwitch } from 'antd';

const Switch = ({ value, checked, onChange, checkedChildren, unCheckedChildren, ...switchProps }) => {
  const [currentValue, setCurrentValue] = useState(checked ?? value);
  const label = currentValue ? checkedChildren : unCheckedChildren;

  const handleChange = (newChecked) => {
    setCurrentValue(newChecked);
    onChange?.(newChecked);
  };

  const handleLabelClick = () => {
    const newValue = !currentValue;
    setCurrentValue(newValue);
    onChange?.(newValue);
  };

  return (
    <div className="flex items-center gap-3">
      <AntSwitch size="default" checked={currentValue} onChange={handleChange} {...switchProps} />

      {label && (
        <span className="text-base cursor-pointer select-none" onClick={handleLabelClick}>
          {label}
        </span>
      )}
    </div>
  );
};

export default Switch;
